module.exports = __webpack_public_path__ + "static/media/sitemap2.89aa55d5.svg";